/* relevanssi — when the visitor arrives on a page from search
   (?highlight=…), Relevanssi wraps each match in a query-term span.
   Scroll to the first one so the matched text is in view (the gap above
   it comes from the span's own scroll-margin-top in colors.css, the same
   convention .pathway-anchor uses). When the visitor prefers reduced
   motion, jump straight to it instead of animating. */

const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
const firstHighlight       = document.querySelector( '.relevanssi-query-term' );

if ( firstHighlight ) {
	firstHighlight.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth' });
}
